import React, { PureComponent } from 'react'
import styled, { keyframes } from 'styled-components'
import getFont from '../../../helpers/fonts/fonts'
import sessionTypes from '../../../helpers/enums/sessionTypes'
import icon from '../../../assets/icons/time-to-climb-icon.svg'

const fadeIn = keyframes`
  0% {
    opacity: 0;
    animation-timing-function: ease-out;
  }
  100% {
    opacity: 1;
  }
`

const boxFadeIn = keyframes`
  0% {
    opacity: 0.1;
    transform: scale(0.95, 0.95);
    animation-timing-function: ease-out;
  }
  100% {
    transform: scale(1, 1);
    opacity: 1;
  }
`

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	animation: ${fadeIn} 0.5s;
	animation-fill-mode: both;
	background-color: rgba(21, 45, 57, 0.85);
	text-align: center;
	position: absolute;
	top: 0;
	left: 0;
`

const Container = styled.div`
	max-width: 630px;
	width: 100%;
	max-height: 100%;
	animation: ${boxFadeIn} 0.5s 0.1s;
	animation-fill-mode: forwards;
	background-color: rgb(255, 255, 255);
	border-radius: 5px;
	display: inline-block;
	opacity: 0;
	overflow: auto;
	vertical-align: middle;
	@media (max-width: ${630}px) {
		border-radius: 0px;
	}
`
// This vertical line is to vertically align the settings container
const Line = styled.div`
	width: 0px;
	height: 100%;
	display: inline-block;
	vertical-align: middle;
`

const Content = styled.div`
	font-family: ${getFont('primaryMedium')};
	font-size: 22px;
	padding: 0 10% 5% 10%;
`

const IconContainer = styled.div`
	width: 100%;
	height: 72px;
	padding-top: 10px;
`

const Icon = styled.img`
	vertical-align: top;
`

interface IBlockedUserProps {
	canParticipate: boolean
	sessionType: string | number
}
class BlockedUser extends PureComponent<IBlockedUserProps> {
	render() {
		if (this.props.canParticipate) {
			return null
		}
		const message =
			this.props.sessionType === sessionTypes.LIVE_SESSION
				? 'This activity has reached the maximum amount of students. Please wait for your teacher so you can move to the next slide.'
				: 'This activity has reached the maximum amount of students. Please click on the arrow to move to the next slide.'
		return (
			<Wrapper>
				<Container>
					<IconContainer>
						<Icon src={icon} />
					</IconContainer>
					<Content>
						We&apos;re sorry!
						<br />
						{message}
					</Content>
				</Container>
				<Line />
			</Wrapper>
		)
	}
}

export default BlockedUser
